import en from './en.json'
import ru from './ru.json'
import zh from './zh.json'
import ja from './ja.json'
import ko from './ko.json'

const translations = {
  en: { translation: en },
  ru: { translation: ru },
  zh: { translation: zh },
  ja: { translation: ja },
  ko: { translation: ko },
}

export default translations
